import { defineComponent as a, openBlock as r, createBlock as l, unref as p, mergeProps as i, withCtx as h, createElementVNode as t } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ a({
  name: "IconPrint",
  __name: "IconPrint",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (v, e) => (r(), l(p(m), i(o, { "view-box": "0 0 24 24" }), {
      default: h(() => [...e[0] || (e[0] = [
        t("path", { d: "M17 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }, null, -1),
        t("path", {
          "fill-rule": "evenodd",
          d: "M7.5 3.25A1.25 1.25 0 0 0 6.25 4.5v2.76a3.25 3.25 0 0 0-3 3.24v6a1.25 1.25 0 0 0 1.25 1.25h1.115l-.258 1.544A1.25 1.25 0 0 0 6.59 20.75h10.82a1.25 1.25 0 0 0 1.233-1.456l-.258-1.544H19.5a1.25 1.25 0 0 0 1.25-1.25v-6a3.25 3.25 0 0 0-3-3.24V4.5a1.25 1.25 0 0 0-1.25-1.25h-9M6.19 14.295 5.865 16.25H4.75V10.5A1.75 1.75 0 0 1 6.5 8.75h11a1.75 1.75 0 0 1 1.75 1.75v5.75h-1.115l-.326-1.956a1.25 1.25 0 0 0-1.233-1.044H7.423a1.25 1.25 0 0 0-1.233 1.044M16.25 7.25v-2.5h-8.5v2.5h8.5m-8.615 7.5-.75 4.5h10.23l-.75-4.5h-8.73",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
